import { PLAN_STATUS } from "@/data/plans";

import { StatusBadgeVariant } from "../ui";

interface StatusInfo {
  id: string;
  label: string;
  value: string;
  isStatus: boolean;
  theme: StatusBadgeVariant;
}

interface GetSubscriptionStatusInfoParams {
  planStatus: string | undefined;
  cancelAt: number | null | undefined;
  todayTimestamp: number;
}

/**
 * Returns the subscription status info based on plan status and cancellation details
 */
export function getSubscriptionStatusInfo({
  planStatus,
  cancelAt,
  todayTimestamp,
}: GetSubscriptionStatusInfoParams): StatusInfo | null {
  const isPlanActive = planStatus === PLAN_STATUS.ACTIVE;
  const isPlanPaused = planStatus === PLAN_STATUS.PAUSED;
  const isPlanOnTrial = planStatus === PLAN_STATUS.TRIALING;
  const isPlanCancelled = planStatus === PLAN_STATUS.CANCELED;
  const isPlanExpired = planStatus === PLAN_STATUS.EXPIRED;

  // Check if plan will cancel in the future
  const willCancelInFuture = cancelAt
    ? todayTimestamp < cancelAt * 1000
    : false;

  if (isPlanPaused) {
    return {
      id: "subscriptionInfo_status",
      label: "STATUS",
      value: "PAUSED",
      isStatus: true,
      theme: "paused",
    };
  }

  if (isPlanOnTrial) {
    return {
      id: "subscriptionInfo_trial_status",
      label: "STATUS",
      value: "TRIAL",
      isStatus: true,
      theme: "trial",
    };
  }

  if (isPlanActive && willCancelInFuture) {
    return {
      id: "subscriptionInfo_cancelling_status",
      label: "STATUS",
      value: "EXPIRING",
      isStatus: true,
      theme: "expiring",
    };
  }

  if (isPlanCancelled) {
    return {
      id: "subscriptionInfo_cancelled_status",
      label: "STATUS",
      value: "CANCELED",
      isStatus: true,
      theme: "canceled",
    };
  }

  if (isPlanExpired) {
    return {
      id: "subscriptionInfo_expired_status",
      label: "STATUS",
      value: "EXPIRED",
      isStatus: true,
      theme: "expired",
    };
  }

  return null;
}
